import PropTypes from "prop-types";
import React from "react";
import styles from "./UspCard.css";
import uspCard from "./images/uspcard.png";

const UspCard = ({ title, description, icon }) => {
    return (
        <div styleName="styles.highlight">
            <img
                styleName="styles.BG"
                src={uspCard}
                alt="background"
            />
            <div styleName="styles.frame">
                <img
                    styleName="styles.diamond"
                    src={icon}
                    alt="icon"
                />
                <div styleName="styles.headingAboutThe">{title}</div>
            </div>
            <p styleName="styles.noMoreLongForms">{description}</p>
        </div>
    );
};

UspCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
};

export default UspCard;
